<template>
  <div>
    <a-table :pagination="pagination" :scroll="{ x: 1200 }" :row-selection="rowSelection" :columns="tableColumns" size="middle" :data-source="tableData" row-key="service_id" :loading="loading" @change="handlePageChange">
      <span slot="action" slot-scope="text, record">
        <a v-dis="{ code: 'system:service:edit', project: 0 }" @click="onEdit(record)">编辑</a>
        <a-divider type="vertical" />
        <a v-dis="{ code: 'system:service:delete', project: 0 }" @click="onDelete(record)">删除</a>
      </span>
      <span slot="service_type" slot-scope="text, record">
        <a-tag v-if="record.service_type" :color="record.service_type.color">{{ record.service_type.label }}</a-tag>
      </span>
      <span slot="owner" slot-scope="text, record">
        {{ record.owner.nickname }}
      </span>
      <span slot="projects" slot-scope="text, record">
        <a-popover v-if="record.projects !== null">
          <template slot="content">
            <a-tag v-for="(item, index) in record.projects" :key="index" color="green">{{ item.project_name }}</a-tag>
          </template>
          <span>
            <a-tag v-for="(item, index) in record.projects" :key="index" color="green">{{ item.project_name }}</a-tag>
          </span>
        </a-popover>
      </span>
      <span slot="special_tests" slot-scope="text, record">
        <a-popover v-if="record.special_tests !== null">
          <template slot="content">
            <a-tag v-for="(item, index) in record.special_tests" :key="index" :color="serviceSpecialTests[item].color">{{ serviceSpecialTests[item].label }}</a-tag>
          </template>
          <span>
            <a-tag v-for="(item, index) in record.special_tests" :key="index" :color="serviceSpecialTests[item].color">{{ serviceSpecialTests[item].label }}</a-tag>
          </span>
        </a-popover>
      </span>
      <span slot="language" slot-scope="text, record">
        <a-tag v-if="record.language" color="red">{{ record.language }}</a-tag>
      </span>
      <span slot="strategy" slot-scope="text, record">
        <a-popover v-if="record.strategy !== null">
          <template slot="content">
            <template v-for="(item, key) in record.strategy">
              <a-tag v-if="serviceStrategys[item]" :key="key" :color="serviceStrategys[item].color">{{ serviceStrategys[item].name }}</a-tag>
            </template>
          </template>
          <span>
            <template v-for="(item, key) in record.strategy">
              <a-tag v-if="serviceStrategys[item]" :key="key" :color="serviceStrategys[item].color">{{ serviceStrategys[item].name }}</a-tag>
            </template>
          </span>
        </a-popover>
      </span>
    </a-table>
  </div>
</template>

<script>
import { serviceSpecialTests } from '@/utils/dictionary';
import { serviceList, serviceDelete } from '@/api/system/service';

const columns = [
  {
    title: '服务ID',
    dataIndex: 'service_id',
    key: 'service_id',
    align: 'center',
    width: 70
  },
  {
    title: '服务名称',
    dataIndex: 'service_name',
    ellipsis: true,
    width: 240,
    key: 'service_name'
  },
  {
    title: '服务类型',
    key: 'service_type',
    dataIndex: 'service_type',
    align: 'center',
    width: 100,
    scopedSlots: { customRender: 'service_type' }
  },
  {
    title: '备注',
    width: 160,
    ellipsis: true,
    key: 'description',
    dataIndex: 'description'
  },
  {
    title: '自动发布',
    width: 80,
    align: 'center',
    dataIndex: 'auto_deploy',
    customRender: text => (text === 1 ? '是' : '否')
  },
  {
    title: '自助发布',
    width: 80,
    align: 'center',
    dataIndex: 'self_deploy',
    customRender: text => (text === 1 ? '是' : '否')
  },
  {
    title: '关联项目',
    key: 'projects',
    width: 200,
    ellipsis: true,
    dataIndex: 'projects',
    scopedSlots: { customRender: 'projects' }
  },
  {
    title: '专项测试',
    key: 'special_tests',
    width: 200,
    ellipsis: true,
    dataIndex: 'special_tests',
    scopedSlots: { customRender: 'special_tests' }
  },
  {
    title: '发布策略',
    key: 'strategy',
    width: 120,
    ellipsis: true,
    dataIndex: 'strategy',
    scopedSlots: { customRender: 'strategy' }
  },
  {
    title: '语言',
    key: 'language',
    width: 100,
    ellipsis: true,
    dataIndex: 'language',
    scopedSlots: { customRender: 'language' }
  },
  {
    title: '负责人',
    dataIndex: 'owner',
    key: 'owner',
    align: 'center',
    width: 100,
    ellipsis: true,
    scopedSlots: { customRender: 'owner' }
  },
  {
    title: '操作',
    align: 'center',
    width: 100,
    fixed: 'right',
    showTypes: ['system'],
    scopedSlots: { customRender: 'action' }
  }
];

export default {
  props: {
    type: {
      type: String,
      default: 'system'
    },
    serviceStrategys: {
      type: Object,
      default: () => {
        return {};
      }
    },
    projectId: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      columns,
      serviceSpecialTests,
      loading: true,
      tableData: [],
      selectedRowKeys: [],
      pagination: {
        size: 'large',
        total: 0,
        pageSize: this.$store.getters.pageSize, // 每页中显示10条数据
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50', '100'], // 每页中显示的数据
        showTotal: total => `共 ${total} 条` // 分页中显示总的数据
      }
    };
  },
  computed: {
    tableColumns() {
      return this.columns.filter(item => !item.showTypes || item.showTypes.includes(this.type));
    },
    rowSelection() {
      return this.type === 'system' ? { columnWidth: 60, selectedRowKeys: this.selectedRowKeys, onChange: this.onSelectChange } : null;
    }
  },
  methods: {
    /**
     * 点击编辑
     */
    onEdit(record) {
      this.$emit('edit', record);
    },

    /**
     * 点击删除
     */
    onDelete(record) {
      const self = this;
      this.$confirm({
        title: '确认',
        content: '确认要删除该服务吗',
        okText: '确定',
        okType: 'danger',
        cancelText: '取消',
        onOk() {
          serviceDelete({ service_id: record.service_id }).then(() => {
            self.$message.success('删除成功');
            self.getServiceList();
          });
        }
      });
    },

    /**
     * 筛选
     * @param {*} filter
     */
    setFilter(filter) {
      this.filterForm = { ...filter };
      this.customerFields = this.filterForm.fields || [];
      this.pagination.pageSize = this.$store.getters.pageSize;
      this.pagination.current = 1;
      this.getServiceList();
    },

    /**
     * 选择行
     * @param {*} selectedRowKeys
     */
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
    },

    /**
     * 获取服务列表
     */
    getServiceList() {
      this.loading = true;
      this.selectedRowKeys = [];
      serviceList({
        ...this.filterForm,
        page_size: this.pagination.pageSize,
        page_number: this.pagination.current
      })
        .then(res => {
          this.tableData = res.data.services;
          this.pagination.total = res.data.total;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },

    /**
     * 页面变更
     * @param {*} pagination
     */
    handlePageChange(pagination) {
      this.pagination = pagination;
      this.getServiceList();
    }
  }
};
</script>
